import SummaryCollectionInterface from '@/utilities/bid/cost/Interfaces/SummaryCollectionInterface'
import TotalCollectionInterface from '@/utilities/bid/cost/Interfaces/TotalCollectionInterface'
import TotalEnum from './enums/TotalEnum'

class Totals {
  collection: Array<SummaryCollectionInterface> = []
  constructor(collection: Array<SummaryCollectionInterface>) {
    this.collection = collection
  }

  getSum(ref: string): number {
    let total = 0.0
    this.collection.forEach((element: any) => {
      total += parseFloat(element[ref])
    })
    return parseFloat(total.toFixed(2))
  }

  getPercentage(cost: number = 0, fee: number = 0): number {
    return fee > 0 ? parseFloat(((100 * (fee - cost)) / fee).toFixed(2)) : 0.0
  }

  getAll(): Array<TotalCollectionInterface> {
    return [
      { id: 0, ref: TotalEnum.COST, value: this.getSum('cost') },
      { id: 1, ref: TotalEnum.MPERCENT, value: this.getPercentage(this.getSum('cost'), this.getSum('fee')) },
      { id: 2, ref: TotalEnum.MVALUE, value: this.getSum('value') },
      { id: 3, ref: TotalEnum.FEE, value: this.getSum('fee') },
    ]
  }
}

export default Totals
